import { ComponentProps } from 'react';

import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { SEPARATOR_TEST_IDS } from '@/constants/data-testids';
import { cn } from '@/utils/tailwind';

type SeparatorProps = ComponentProps<typeof SeparatorPrimitive.Root>;

const Separator = ({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: SeparatorProps) => {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      data-testid={SEPARATOR_TEST_IDS.SEPARATOR}
      className={cn(
        'bg-custom-warm-grey-200 shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className
      )}
      {...props}
    />
  );
};

export { Separator };
